import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ButtonDirective } from 'primeng/button'
import { Router } from '@angular/router'
import { PermissionService } from '@core/auth/services/permission.service'
import { Tooltip } from 'primeng/tooltip'

@Component({
  selector: 'albert-template-cta-button',
  imports: [
    ButtonDirective,
    Tooltip
  ],
  templateUrl: './template-cta-btn.component.html',
  styleUrl: './template-cta-btn.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateCtaButtonComponent {
  protected readonly router = inject(Router)
  protected readonly permissionService = inject(PermissionService)

}
